import "cleave.js/dist/addons/cleave-phone.tz";
import React, { useState } from 'react'
import Cleave from 'cleave.js/react';
import debounce from 'lodash.debounce';

const PhoneInput = ({ clearState, containerStyle, label = 'Namba ya Simu', ...props }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  return (
    <label style={containerStyle}>{label}: <small style={{ fontWeight: 'normal' }}>(mf. 0777 888 999)</small>
      <div style={{ position: 'relative', flex: 1 }}>
        <Cleave
          name="namba"
          placeholder="Andika namba ya simu hapa"
          options={{
            phone: true,
            phoneRegionCode: 'TZ'
          }}
          {...props}
          onChange={debounce((event) => {
            setPhoneNumber(event.target.value);
            props?.onChange?.(event.target.value);
          }, 500)}
        />
        {phoneNumber ? (
          <button
            onClick={() => {
              setPhoneNumber();
              clearState?.();
            }}
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              cursor: 'pointer',
              margin: 0,
            }}
          >
            x
          </button>
        ) : null}
      </div>
    </label>
  );
}

export default PhoneInput;
